import { TGetContext, TOnlineBank } from '@api/lendingAPI/lapi.types';

type TOnlineBankWithProvider = TOnlineBank & {
    provider: 'truelayer' | 'finapi';
};

export const getBanksFromContext = (context: TGetContext['data']) => {
    let truelayerBanks: TOnlineBankWithProvider[] = [];
    let finapiBanks: TOnlineBankWithProvider[] = [];

    if (context) {
        if (context.open_banking.truelayer_banks) {
            truelayerBanks = context.open_banking.truelayer_banks.map(
                (bank) => ({
                    ...bank,
                    provider: 'truelayer' //add provider identifier for authURL requeset routing
                })
            );
        }
        if (context.open_banking.finapi_banks) {
            finapiBanks = context.open_banking.finapi_banks.map((bank) => ({
                ...bank,
                provider: 'finapi' //add provider identifier for authURL requeset routing
            }));
        }
    }
    return [...truelayerBanks, ...finapiBanks];
};
